<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" >
          <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Player Achivements - {{userName | titlecase}}<span class="badge">{{totalRecords }}</span></h4>
            </div>
            <div class="rightDiv">
                <!-- <button class="exportBTn">
                    <span>
                        <img src="../../../assets/images/backend-image/header/exportIcon.svg" alt="">
                    </span> Export
                </button> -->
            </div>
        </div>
            <div class="mainDivBody">
            <div class="maintableDiv">
                 <div class="tableParanet">
                     <p-table id="vdtnetable10" #dt [value]="matchList" [paginator]="true" [rows]="10"
                            [rowsPerPageOptions]="paginationOption" [lazy]="true" scrollHeight="auto"
                            scrollDirection="horizontal" [totalRecords]="totalRecords" [loading]="loading"
                            [scrollable]="true" cellpadding="0" class="transaction-history"
                            (onLazyLoad)="getMyTournamentList($event)" aria-describedby="vdtnetable10_info">
                            <ng-template pTemplate="header">
                                <tr>

                                    <th pSortableColumn="tournamentName"  rowspan="1" colspan="1" class="tournamentNameTd" >
                                        <div>Tournament Name
                                            <p-sortIcon field="tournamentName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="matchName" class="matchNameTD" rowspan="1" colspan="1" cl>
                                        <div>Categories
                                            <p-sortIcon field="matchName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="agegroupName" class="agegroupNameTd" rowspan="1" colspan="1">
                                        <div>Age Group
                                            <p-sortIcon field="agegroupName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="entryFee" class="entryFeeTd" rowspan="1" colspan="1">
                                        <div>Entry Fees
                                            <p-sortIcon field="entryFee"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th pSortableColumn="pointsEarn" class="pointsEarn" rowspan="1"
                                        colspan="1">
                                        <div>Position
                                            <p-sortIcon field="pointsEarn"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="lastdateofwithdraw" class="lastdateofwithdrawTd" rowspan="1"
                                        colspan="1">
                                        <div>Points Earn
                                            <p-sortIcon field="lastdateofwithdraw"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="tournamentEndDate" class="tournamentEndDateTd" rowspan="1"
                                        colspan="1">
                                        <div> Date
                                            <p-sortIcon field="tournamentEndDate"></p-sortIcon>
                                        </div>
                                    </th>
                                    <!-- <th pSortableColumn="tournamentStatus" class="sorting_disabled" rowspan="1"
                                        colspan="1" >
                                        <div>Status
                                            <p-sortIcon field="tournamentStatus"></p-sortIcon>
                                        </div>
                                    </th> -->
                                    <th class="actionTD p-frozen-column" rowspan="1" colspan="1">
                                        <div>Action

                                        </div>
                                    </th>

                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-matchList>
                                <tr>
                                    <td>
                                        {{matchList.tournamentName}}

                                    </td>
                                    <td>
                                        {{matchList.matchName}}

                                    </td>
                                    <td>

                                        {{matchList.ageGroupName}}
                                    </td>
                                    <td>
                                        ₹ {{matchList.entryFee}}

                                    </td>

                                    <td>
                                        {{matchList.position}}

                                    </td>
                                    <td>
                                        {{matchList.pointsEarn}}

                                    </td>
                                    <td>
                                        {{matchList.tournamentEndDate | date : 'dd/MM/yyyy'}}

                                    </td>
                                    <!-- <td><span class="rin-type-label state-finished">
                                            {{matchList.tournamentStatus}}
                                        </span></td> -->
                                    <td class="actionTD p-frozen-column">
                                        <div class="status-buttons">
                                            <button *ngIf="matchList.certificatePic" class="downloadCertifcateBtn"
                                                (click)="downloadPdf(matchList.certificatePic)"
                                                id="withdrawal-btn"><span> <img src="../../../../assets/images/backend-image/common-images/download.svg" alt=""></span>
                                               <span class="titleDiv">Download Certificate</span> </button>
                                        </div>
                                        <!-- <div class="disableBtn status-buttons" *ngIf="matchList.showWithdraw == false"
                                            pTooltip="Withdrawal Date Expired" tooltipPosition="top">
                                            <button class="btn btn-success"
                                                (click)="withdrawModal(matchList.id,matchList.tournamentName,matchList.matchName,matchList.ageGroupName)"
                                                id="withdrawal-btn" disabled><span><i class="bx bx-exit"></i></span>
                                                Withdraw</button>
                                        </div> -->
                                    </td>
                                </tr>
                            </ng-template>
                            <!-- <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    Total {{totalRecords }} Achivements
                                </div>
                            </ng-template> -->
                        </p-table>
                 </div>
            </div>
        </div>
    </div>
</div>
 
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdrawinfo"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '38rem' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw</h5>
                <div class="headings col-md-12">

                    <h6>{{tname}}</h6>


                    <div class="countdown-container">
                        <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
                        <div class="countdown-text">{{ countdown }}</div>
                        <br>

                    </div>
                    <div class="timer-alert">
                        Please wait
                    </div>
                    <p class="note">We are processing your request for a refund in the tournament category. Once the
                        refund
                        process is successfully completed, please check wallet Balance.</p>

                </div>

            </div>
        </div>
    </div>
</p-dialog>


<p-dialog id="widthdraw-confitmation" [(visible)]="WithdrawcnfModal"
    [breakpoints]="{ '960px': '75vw' , '768px': '100%'}" [style]="{ width: '38rem' }" [modal]="true" [draggable]="false"
    [resizable]="false">
    <!---test-->

    <div class="modal-dialog w-100 modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important; width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Withdraw Confirmation
                </h5>
            </div>
            <div class="modal-body">

                <p>
                    Are you sure you want to withdraw from the tournament? Please note that this action cannot be
                    undone, and your participation in the tournament will be canceled.
                </p>


                <div class="add-even col-md-12">
                    <!-- <div class="event-number">Add Partner</div> -->

                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">
                                <div class="title">{{tname}}</div>
                                <div class="Event-cate">
                                    <ul>
                                        <li>
                                            <span class="small-heading">{{mtn}}</span>
                                            <p>{{agn}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                    <p>
                        After the withdrawal, the entry fee amount will be credited back to your TPL wallet. in cash
                        within 4
                        days.
                    </p>


                    <!-- <div class="add-btn col-md-12">
  <button> Add Another Event <i class='bx bx-plus'></i> </button>
</div> -->

                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary mx-auto " (click)="thankyouwithdraw()">Proceed with the
                    withdrawal</button>
            </div>
        </div>


    </div>

</p-dialog>
<p-dialog id="Entertournamentthankadmin" [(visible)]="thankwithdraw"
    [breakpoints]="{ '960px': '75vw', '768px': '100%' }" [style]="{ width: '500px' }" [modal]="true" [draggable]="false"
    [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry
                </h5>
                <div class="headings col-md-12">
                    <h6>Davis Cup Qualifiers
                    </h6>
                    <p class="note">
                        Your Tournament withdrawals have been successfully processed.


                    </p>
                </div>

            </div>

        </div>


    </div>

</p-dialog>